import { render } from "./PartnerDashboardSettings.vue?vue&type=template&id=69a1d58a&scoped=true"
import script from "./PartnerDashboardSettings.vue?vue&type=script&lang=js"
export * from "./PartnerDashboardSettings.vue?vue&type=script&lang=js"

import "./PartnerDashboardSettings.vue?vue&type=style&index=0&id=69a1d58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a1d58a"]])

export default __exports__